import { AppSignature } from 'src/app/models/app-signature';
import { AddressModel } from 'src/app/models/address.model';
import { FileTransferModel } from 'src/app/models/file-transfer';
import { Board } from 'src/app/models/master.model';
import { GradeModel } from '../../../models/master.model';
import { SubscriptionDTO } from '../../institute-subscription/models/subscription.model';
import { WatchedVideoModel } from '../../resource/models/video.model';

export class InstituteModel extends AppSignature {
  name: string;
  code: string;
  email: string;
  phone: string;
  contactPersonName: string;
  contactPersonDesignation: string;
  fax: string;
  websiteUrl: string;
  profileImage: string;
  registrationNumber: string;
  registrationDate: string;
  businessModelType: number;
  status: number;
  isActive: boolean;
  applicationMode: number;
  alternateEmail: string;
  alternatePhone: string;
  parentAddress: AddressModel = new AddressModel();
  instituteSource: InstituteSource;
  parentReferrerID: string;
  contactPersonID: string;
  classes: string;
  noOfSections: number;
  averageSectionStrength: number;
  approxSchoolStrength: number;
  demoExpiryDate: string;
  isLeadInstitute: boolean;
  parentAddressID: string;
  leadStatus: number;
  displayName: string;
  enableBranding: boolean;
  enableEventNotification: boolean;
  enableEventCalendar: boolean;
  enableUpsell: boolean;
  enableFeePayment: boolean;
  enableTimetable: boolean;
  enablePreSchool: boolean;
}

export class ContactPerson extends AppSignature {
  name: string;
  phoneNumber: string;
  designation: string;
  email: string;
  parentStaffID: string;
  salutation: string;
  gender: string;
  parentNotebookLeadInstituteID: string;
}
export class InstituteDTO {
  institute: InstituteModel = new InstituteModel();
  boards: Array<Board> = new Array<Board>();
  grade: Array<GradeModel> = new Array<GradeModel>();
  instituteAdmin: ContactPerson = new ContactPerson();
  logo: FileTransferModel = new FileTransferModel();
  contactPersonList: Array<ContactPerson> = new Array<ContactPerson>();
  profileImage: FileTransferModel = new FileTransferModel();
  hasSubscription: boolean;
  usernameValid = true;
  hasQuotation: boolean;
  createContactPersonLogin = false;
}

export class InstituteWatchedVideoDTO extends InstituteDTO {
  watchedVideo: Array<WatchedVideoModel> = [];
}

export class InstituteView extends InstituteDTO {
  subscriptions: Array<SubscriptionDTO> = [];
}

export class BoardGrades {
  board: Board;
  grades: Array<GradeModelUpsellModel> = [];
}

export class GradeModelUpsellModel {
  grade: GradeModel;
  isUpsell: boolean = false;
}

export class BoardGradeMap {
  board: Board;
  grade: GradeModel;
  paid: boolean = false;
  isUpsell: boolean = false;
}

export class ClassMap {
  board: Board;
  class: Array<BoardGradeMap> = [];
}

export class InstituteDiscountModel extends AppSignature {
  isActive: boolean;
  parentInstituteID: string;
  discount: number;
  discountType: number;
}

export class InstituteDiscountDTO {
  instituteDiscount: InstituteDiscountModel = new InstituteDiscountModel();
}

export enum InstituteSource {
  NA = 0,
  BrainBoxSchool = 1
}

